import React, { useState } from "react";
import * as XLSX from "xlsx";
import * as hrmsService from "../../../services/hrmsService";
import { EmptyState, LoadState, SecondaryButton } from "../hrComponents";
import { cardStyle, tdStyle, thStyle, useLoad } from "../hrUi";
import { defaultPayMonth, formatMoney } from "./payrollHelpers";

// The monthly end-of-service provision (UAE): what is owed at the end of the month, less what was owed the month before.
export default function PayrollReportsTab() {
  const [month, setMonth] = useState(defaultPayMonth());
  const { data, loading, error, reload } = useLoad(() => hrmsService.getEosbProvision(month), [month]);
  const rows = data?.rows || [];

  const exportSheet = () => {
    const sheet = [["Code", "Name", "Joined", "Basic (monthly)", "Service (years)", "Owed last month", "Provision", "Owed now"], ...rows.map((r) => [r.employee_code, r.full_name, r.date_of_joining, r.basic_monthly, r.service_years, r.opening, r.provision, r.closing])];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(sheet), "EOSB provision");
    XLSX.writeFile(wb, `eosb-provision-${month}.xlsx`);
  };

  return (
    <>
      <div className="d-flex flex-wrap gap-3 align-items-end mb-3">
        <div>
          <label style={{ fontSize: 13, fontWeight: 600, display: "block" }} htmlFor="eosb-month">
            End-of-service provision for
          </label>
          <input id="eosb-month" type="month" className="form-control" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} />
        </div>
        <SecondaryButton onClick={exportSheet} disabled={!rows.length}>
          Download Excel
        </SecondaryButton>
      </div>
      <LoadState loading={loading} error={error} onRetry={reload}>
        {rows.length === 0 ? (
          <EmptyState title="Nobody to show" text="People need a salary with a basic pay component to be included." />
        ) : (
          <div style={{ ...cardStyle, overflowX: "auto" }}>
            <table className="table mb-0" style={{ minWidth: 720 }}>
              <thead>
                <tr>
                  {["Employee", "Basic", "Years", "Owed last month", "Provision", "Owed now"].map((h, i) => (
                    <th key={h} style={{ ...thStyle, textAlign: i ? "right" : "left" }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.employee_id}>
                    <td style={tdStyle}>
                      {r.full_name}
                      <div style={{ fontSize: 12, color: "#6B7280" }}>{r.employee_code}</div>
                    </td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>{formatMoney(r.basic_monthly)}</td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>{r.service_years}</td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>{formatMoney(r.opening)}</td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>{formatMoney(r.provision)}</td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>{formatMoney(r.closing)}</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: 700 }}>
                  <td style={tdStyle}>Total</td>
                  <td style={tdStyle} />
                  <td style={tdStyle} />
                  <td style={{ ...tdStyle, textAlign: "right" }}>{formatMoney(data.totals.opening)}</td>
                  <td style={{ ...tdStyle, textAlign: "right" }}>{formatMoney(data.totals.provision)}</td>
                  <td style={{ ...tdStyle, textAlign: "right" }}>{formatMoney(data.totals.closing)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {data?.no_basic?.length ? <div style={{ fontSize: 12, color: "#92400E", marginTop: 8 }}>Left out because their salary has no basic pay: {data.no_basic.join(", ")}</div> : null}
      </LoadState>
    </>
  );
}
